import { render } from "./fldRichtext.vue?vue&type=template&id=1caf95b2"
import script from "./fldRichtext.vue?vue&type=script&lang=js"
export * from "./fldRichtext.vue?vue&type=script&lang=js"

import "./fldRichtext.vue?vue&type=style&index=0&id=1caf95b2&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QField from 'quasar/src/components/field/QField.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QEditor,QField,QColor});
